import { gql } from "@/__generated__/gql";

export const CHAT_CHANNELS_QUERY = gql(`
  query OrganizationChatChannels(
    $orgId: ID!,
    $hasBeenUsedForLiveEvent: Boolean,
    $ordering: [ChatChannelOrderingInput!]!,
  ) {
    node(id: $orgId) {
      ... on Organization {
        id
        __typename
        chatChannels(
          hasBeenUsedForLiveEvent: $hasBeenUsedForLiveEvent
          ordering: $ordering
        ) {
          edges {
            node {
              id
              roomName
              displayName
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
          totalCount
        }
      }
    }
  }
`);
